import type { ComponentProps } from "react";

import { cn } from "./cn";

/**
 * A choice chip. Its state comes from ARIA, so assistive tech and the look always agree:
 * aria-pressed (toggle / multi-choice) or role="radio" + aria-checked (single choice).
 */
export function Chip({ className, type, ...props }: ComponentProps<"button">) {
  return (
    <button
      type={type ?? "button"}
      className={cn(
        "inline-flex min-h-9 cursor-pointer items-center rounded-full border border-border bg-card px-3.5 text-left text-[0.9rem] transition-colors hover:border-primary disabled:cursor-not-allowed disabled:opacity-45",
        "aria-pressed:border-foreground aria-pressed:bg-foreground aria-pressed:text-background",
        "aria-checked:border-foreground aria-checked:bg-foreground aria-checked:text-background",
        className,
      )}
      {...props}
    />
  );
}

export function ChipGroup({ className, ...props }: ComponentProps<"div">) {
  return <div className={cn("flex flex-wrap gap-1.5", className)} {...props} />;
}
